import { createBlock } from '../DocEditor';

/**
 * Enter in the doc title — same as breaking a body block: text before the
 * caret stays as the title; text after (or empty) becomes a new text block
 * at the top of the body.
 */
export function splitTitleOnEnter(title, selectionStart, selectionEnd, blocks) {
  const start = selectionStart ?? title.length;
  const end = selectionEnd ?? start;
  const before = title.slice(0, start);
  const after = title.slice(end);
  const newBlock = createBlock('text', after);
  return {
    title: before,
    blocks: [newBlock, ...(blocks || [])],
    focusBlockId: newBlock.id,
  };
}
